import { useMemo, useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { LocationTarget } from '../util/index';

function useLocationTargetDescription(
  location,
  targetingType,
  radiusValue,
  radiusUnit,
  isRadiusTarget
) {
  const i18n = useContext(I18nContext);

  const locationTarget = useMemo(() =>
    new LocationTarget(
      location,
      targetingType,
      isRadiusTarget ? radiusValue : null,
      isRadiusTarget ? radiusUnit : null
    ), [isRadiusTarget, location, radiusUnit, radiusValue, targetingType]);

  return i18n.getString(_TL_('Target {{description}}'), { description: locationTarget.getDescription(i18n) });
}
export default useLocationTargetDescription;
